var map = {
	"./add-user.svg": "6e7d",
	"./ads.svg": "b7ff",
	"./apple.svg": "d8a3",
	"./background.svg": "a762",
	"./block-button.svg": "ff57",
	"./bold-line.svg": "dfe7",
	"./brand-logos/amex.svg": "b348",
	"./brand-logos/diners.svg": "b20c",
	"./brand-logos/discover.svg": "45ab",
	"./brand-logos/jcb.svg": "7a88",
	"./brand-logos/mastercard.svg": "18c6",
	"./brand-logos/unionpay.svg": "35ce",
	"./brand-logos/visa.svg": "8976",
	"./btn-circle-primary.svg": "d443",
	"./btn-circle.svg": "2051",
	"./btn-rectangle.svg": "f21a",
	"./button-background.svg": "d1e0",
	"./circle-gray-highlight.svg": "1a15",
	"./circle-gray.svg": "92e3",
	"./circle-white.svg": "3088",
	"./circle.svg": "bf9f",
	"./clue-button.svg": "8401",
	"./coin-200x.svg": "1aef",
	"./coin-50x.svg": "8bc4",
	"./coin-small.svg": "52e2",
	"./coin.svg": "8861",
	"./facebook-2.svg": "5da8",
	"./facebook.svg": "aaa3",
	"./fullscreen.svg": "8625",
	"./google-2.svg": "7c51",
	"./google.svg": "0895",
	"./hangman.svg": "7e1b",
	"./icon-back.svg": "2704",
	"./icon-clue-sml.svg": "9eb8",
	"./icon-clue.svg": "79f8",
	"./icon-coin-reward.svg": "ba7c",
	"./icon-coin.svg": "fb14",
	"./icon-coupon-blue.svg": "260c",
	"./icon-coupon-orange.svg": "af6f",
	"./icon-coupon.svg": "51e9",
	"./icon-delete.svg": "7345",
	"./icon-edit.svg": "0f2f",
	"./icon-email.svg": "19d0",
	"./icon-error.svg": "4c4a",
	"./icon-game-help.svg": "939a",
	"./icon-giftbox-button.svg": "cbde",
	"./icon-giftbox.svg": "0c08",
	"./icon-help.svg": "e5e8",
	"./icon-image.svg": "90c1",
	"./icon-league.svg": "83abb",
	"./icon-live.svg": "f75c",
	"./icon-login.svg": "53ca5",
	"./icon-phone.svg": "6ab6",
	"./icon-relive.svg": "a6ef",
	"./icon-sad.svg": "edc3",
	"./icon-score.svg": "2e67",
	"./icon-settings.svg": "426d",
	"./icon-store.svg": "d180",
	"./icon-ticket-reward.svg": "c0d9",
	"./icon-ticket.svg": "557a",
	"./icon-verify.svg": "1d41",
	"./icon-win-coin.svg": "5919",
	"./icon-win.svg": "549a",
	"./line-dashed.svg": "78d2",
	"./line-sm.svg": "92c9",
	"./line-xs.svg": "3e5f",
	"./line.svg": "5fed",
	"./lives.svg": "76e7",
	"./logo.svg": "9b19",
	"./menu.svg": "36be",
	"./moment-logo.svg": "49bc",
	"./play-icon.svg": "c0c8",
	"./plus.svg": "8a37",
	"./ravio_logo.svg": "2945",
	"./raviosoft_logo.svg": "3237",
	"./relive-button.svg": "6ad1",
	"./ribbon-bronze.svg": "b3f5",
	"./ribbon-gold.svg": "f8af",
	"./ribbon-silver.svg": "ad1f",
	"./score.svg": "444b",
	"./scribble-green.svg": "a766",
	"./shopping-cart.svg": "568d",
	"./skip-button.svg": "14b8",
	"./stickman-2.svg": "c68a",
	"./stickman-3.svg": "ff47",
	"./stickman.svg": "9e70",
	"./store/chest-immortal.svg": "b68b",
	"./store/chest.svg": "c404",
	"./store/coin-001.svg": "65ec",
	"./store/coin-002.svg": "b46d",
	"./store/coin-003.svg": "531f",
	"./store/coin-004.svg": "041f",
	"./store/coin-005.svg": "5e9e",
	"./store/coin-006.svg": "6d02",
	"./store/coin-007.svg": "0b5c",
	"./store/hint.svg": "2f60",
	"./store/icon-coupon.svg": "a7c4",
	"./store/open.svg": "a6bb",
	"./store/rewind.svg": "83cf",
	"./store/skip.svg": "149b",
	"./store/ticket-001.svg": "f095",
	"./store/ticket-002.svg": "1ab1",
	"./store/ticket-003.svg": "189c",
	"./store/ticket-004.svg": "4861",
	"./store/ticket-005.svg": "d2e3",
	"./store/ticket-immortal.svg": "7ef8",
	"./ticket.svg": "ba2d",
	"./times-black.svg": "2bcf",
	"./times.svg": "ccb8",
	"./tips-icon.svg": "f2d2",
	"./under-construction.svg": "14ff",
	"./underline-black.svg": "a3b5",
	"./underline-gray.svg": "6eb5",
	"./underline-orange.svg": "0b7c",
	"./underline.svg": "9e44",
	"./winner-stand.svg": "3d3d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";